import { render, staticRenderFns } from "./indexdetail.vue?vue&type=template&id=51f50328&scoped=true&"
import script from "./indexdetail.vue?vue&type=script&lang=js&"
export * from "./indexdetail.vue?vue&type=script&lang=js&"
import style0 from "./indexdetail.vue?vue&type=style&index=0&id=51f50328&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f50328",
  null
  
)

export default component.exports